<template>
    <section class="c-o-section-testimonials">
        <div class="c-o-section-testimonials__wrapper">
            <h2 class="c-o-section-testimonials__title">{{ testimonialsItems.headline }}</h2>
            <div class="c-o-section-testimonials__content">
                <testimonial v-for="(item, key) in testimonialsItems.testimonials_list" :key="key" :testimonial="item"></testimonial>
            </div>
        </div>
    </section>
</template>

<script>

    import Testimonial from '../../molecules/MoleculeTestimonial.vue';

    export default {
        props: ['content', 'data'],
        components: {
            Testimonial
        },
        data() {
            return {
                testimonialPage: true
            }
        },
        computed: {
            testimonialsItems: {
                get(){
                    return this.content.content.acf;
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/page-sections/OrganismSectionTestimonials.vue